import * as React from "react";
import { AccordionQuestionnaireSection } from "@teamprevent/common/questionnaires/components/AccordionQuestionnaireSection";
import { DropdownQuestion } from "@teamprevent/common/questionnaires/components/questions/DropdownQuestion";
import { ImmunisationDecision, ImmunisationDecisions, ImmunisationDecisionResult } from "@teamprevent/common/immunisation/models";

import { ImmunisationType } from "../../crud/immunisationType";

interface Props {
    index?: number;
    readonly: boolean;
    questionnaireKey: string;
    immunisationTypes?: ImmunisationType[];
    initialImmunisationDecisions?: ImmunisationDecisionResult;
    onImmunisationTypeChange?: (id: string, immunisationDecision: string) => void;
}

export const ImmunisationTypesSection: React.FunctionComponent<Props> = (props) => {
    const [immunisationDecisions, setImmunisationDecisions] = React.useState<ImmunisationDecisionResult>({});

    React.useEffect(() => {
        const decisions = { ...immunisationDecisions };

        props.immunisationTypes
            .filter(i => i.requiredForHcwClearance)
            .map(i => decisions[i.id] = props.initialImmunisationDecisions[i.id]);

        setImmunisationDecisions(decisions);
    }, [props.initialImmunisationDecisions]);

    const setDecision = (id: string, immunisationDecision: keyof typeof ImmunisationDecision) => {
        const decisions = { ...immunisationDecisions };
        decisions[id] = ImmunisationDecision[immunisationDecision];
        setImmunisationDecisions(decisions);
    };

    const onImmunisationTypeChange = (id: string, immunisationDecision: keyof typeof ImmunisationDecision) => {
        setDecision(id, immunisationDecision);

        props.onImmunisationTypeChange(id, immunisationDecision);
    };

    return (
        <AccordionQuestionnaireSection
            id="ImmunisationTypes"
            title="Immunisation Checklist"
            index={props.index}
        >
            {props.immunisationTypes
                .filter(i => i.requiredForHcwClearance)
                .map(i =>
                    (<DropdownQuestion
                        key={`ImmunisationType_${i.id}`}
                        readonly={props.readonly}
                        questionConfig={({
                            id: `ImmunisationType_${i.id}`,
                            questionText: `${i.name}`,
                        })}
                        options={ImmunisationDecisions}
                        mandatory
                        onAnswerChange={(value) => onImmunisationTypeChange(`ImmunisationType_${i.id}`, value?.toString() as keyof typeof ImmunisationDecision)}
                        answer={immunisationDecisions[i.id]}
                    />
                    ))
            }
        </AccordionQuestionnaireSection>
    );
};
